export const getNextFileAction = ({
  isActiveCompany,
  isArchived,
}: {
  isActiveCompany: boolean
  isArchived: boolean
}): string => {
  return isActiveCompany ? (isArchived ? "unarchive" : "archive") : "remove"
}
